import React, {Component, Fragment} from 'react';
import Grid from "@material-ui/core/Grid";
import {Add, Domain, HowToVoteOutlined, Person, PersonOutlined, SearchOutlined, HdrStrongOutlined} from "@material-ui/icons";
import TextField from "@material-ui/core/TextField";
import {FieldsJs} from '../../../../settings/General/General';
import Fab from "@material-ui/core/Fab";
import PropTypes from "prop-types";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";


class FiltrosCuentaBancaria extends Component {
	
	state = {};
	
	constructor() {
		super();
		this.state = {
			beneficiario: '',
			rfc: '',
			banco: '',
			numero_cuenta: '',
			activo: 'all',
		};
	}
	
	handleChange = (e, variable, campo, date, input) => {
		FieldsJs.HandleChange(e, variable, campo, date, input, (r) => this.setState({
			[r.name]: r.value
		}));
		setTimeout(() => this.HandleFiltro());
	};
	
	HandleFiltro = () => {
		let filtro = {};
		
		filtro.beneficiario = this.state.beneficiario || null;
		filtro.rfc = this.state.rfc || null;
		filtro.banco = this.state.banco || null;
		filtro.numero_cuenta = this.state.numero_cuenta || null;
		filtro.activo = this.state.activo || null;
		
		this.props.HandleFiltro(filtro);
	};
	
	AplicarFiltro = () => {
		this.props.AplicarFiltros();
	};
	
	
	render() {
		return (
			<Fragment>
				<Grid container spacing={2} alignContent={"flex-end"} alignItems={"flex-end"}>
					
					<Grid item className={'text-left'} xs={12} sm={6} md={2} lg={2} xl={2}>
						<Grid container spacing={1} alignItems={"flex-end"}>
							<Grid item className={'w-30-px'}>
								<PersonOutlined className={'w-100 text-gray'}/>
							</Grid>
							<Grid item className={'w-100-30-px'}>
								<TextField
									type={'text'}
									fullWidth
									name="beneficiario"
									onChange={this.handleChange}
									label="Beneficiario"
									autoComplete={'off'}
									value={this.state.beneficiario}
								/>
							</Grid>
						</Grid>
					</Grid>
					
					<Grid item className={'text-left'} xs={12} sm={6} md={2} lg={2} xl={2}>
						<Grid container spacing={1} alignItems={"flex-end"}>
							<Grid item className={'w-30-px'}>
								<HowToVoteOutlined className={'w-100 text-gray'}/>
							</Grid>
							<Grid item className={'w-100-30-px'}>
								<TextField type={'text'} fullWidth name="rfc"
								           onChange={this.handleChange}
								           inputProps={{maxLength: 13}}
								           label="RFC" autoComplete={'off'}
								           value={this.state.rfc}
								           disabled={this.props.tipo === 'view'}
								/>
							</Grid>
						</Grid>
					</Grid>
					
					<Grid item className={'text-left'} xs={12} sm={6} md={2} lg={2} xl={2}>
						<Grid container spacing={1} alignItems={"flex-end"}>
							<Grid item className={'w-30-px'}>
								<HdrStrongOutlined className={'w-100 text-gray'}/>
							</Grid>
							<Grid item className={'w-100-30-px'}>
								<TextField
									type={'text'}
									fullWidth
									name="banco"
									onChange={this.handleChange}
									label="Banco"
									autoComplete={'off'}
									value={this.state.banco}
								/>
							</Grid>
						</Grid>
					</Grid>
					
					<Grid item className={'text-left'} xs={12} sm={6} md={2} lg={2} xl={2}>
						<Grid container spacing={1} alignItems={"flex-end"}>
							<Grid item className={'w-30-px'}>
								<HdrStrongOutlined className={'w-100 text-gray'}/>
							</Grid>
							<Grid item className={'w-100-30-px'}>
								<TextField
									type={'text'}
									fullWidth
									name="numero_cuenta"
									onChange={this.handleChange}
									label="No. Cuenta"
									autoComplete={'off'}
									value={this.state.numero_cuenta}
								/>
							</Grid>
						</Grid>
					</Grid>
					
					<Grid item xs={6} sm={6} md={6} lg={2} xl={2} align={'left'}>
						<Grid container spacing={1} alignItems={"flex-end"}>
							<Grid item className={'w-30-px'}>
								<HdrStrongOutlined className={'w-100 text-gray'}/>
							</Grid>
							<Grid item className={'w-100-30-px'}>
								<FormControl fullWidth>
									<InputLabel htmlFor="age-native-activo">Activo</InputLabel>
									<Select
										native
										value={this.state.activo}
										onChange={this.handleChange}
										inputProps={{
											name: 'activo',
											id: 'age-native-activo',
										}}
									>
										<option value={'all'}>Todos</option>
										<option value={1}>Activo</option>
										<option value={0}>Inactivo</option>
									</Select>
								</FormControl>
							</Grid>
						</Grid>
					</Grid>
					
					<Grid item xs={12} sm={12} md={12} lg={2} xl={2} align={'right'}>
						<Fab variant="extended" size="small" color="default" aria-label="Add"
						     onClick={this.AplicarFiltro}>
							<SearchOutlined className={'margin-5-R px-14'}/> Buscar
						</Fab>
					</Grid>
				
				</Grid>
			</Fragment>
		);
	}
}

FiltrosCuentaBancaria.propTypes = {
	HandleFiltro: PropTypes.func.isRequired,
	AplicarFiltros: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired
};

export default FiltrosCuentaBancaria;
